module.exports = __webpack_public_path__ + "img/finland-digestive-diseases-male.93426260.png";